// extracted by mini-css-extract-plugin
export var accordion = "_df-0";
export var chevron = "_df-3";
export var closed = "_df-2";
export var content = "_df-4";
export var open = "_df-1";
export var rotate = "_df-5";